import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 查询商品规格列表
export function getProductSpecList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/queryProductSpec',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加商品规格
export function saveProductSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/saveProductSpec',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改商品规格
export function updateProductSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/updateProductSpec',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除商品规格
export function deleteProductSpec(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product/deleteProductSpec',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}